import { PluginListenerHandle } from "@capacitor/core";
import {
  PushNotifications,
  PushNotificationSchema,
  RegistrationError,
  Token,
} from "@capacitor/push-notifications";
import { AndroidSettings, NativeSettings } from "capacitor-native-settings";

import {
  IPushNotificationAdapter,
  PushNotificationActionPerformed,
} from "../IPushNotificationAdapter";
import {
  PushNotificationError,
  PushNotificationErrorType,
} from "../PushNotificationError/PushNotificationError";

export class AndroidPushNotificationAdapter implements IPushNotificationAdapter {
  async requestPermission(): Promise<void> {
    const result = await PushNotifications.requestPermissions();

    if (result.receive != "granted") {
      throw new PushNotificationError(
        PushNotificationErrorType.PERMISSION_ERROR,
        "Push notifications permission denied on Android",
      );
    }
  }

  public async register(): Promise<void> {
    return PushNotifications.register();
  }

  public onRegistrationError(
    callback: (e: RegistrationError) => void,
  ): Promise<PluginListenerHandle> {
    return PushNotifications.addListener("registrationError", callback);
  }

  public onTokenReceived(callback: (token: Token) => void): Promise<PluginListenerHandle> {
    return PushNotifications.addListener("registration", callback);
  }

  public onNotificationReceived(
    callback: (notification: PushNotificationSchema) => void,
  ): Promise<PluginListenerHandle> {
    return PushNotifications.addListener("pushNotificationReceived", callback);
  }

  public onActionPerformed(
    callback: (
      action: PushNotificationActionPerformed<AndroidPushNotificationActionPerformedData>,
    ) => void,
  ): Promise<PluginListenerHandle> {
    return PushNotifications.addListener("pushNotificationActionPerformed", callback);
  }

  public openAppSettings() {
    NativeSettings.openAndroid({
      option: AndroidSettings.ApplicationDetails,
    });
  }
}

export type AndroidPushNotificationActionPerformedData = {
  body: string;
  title: string;
  id?: string;
  data?: {
    "CIO-Delivery-Token": string;
    "body": string;
    "title": string;
    "dataUrl"?: string;
    "CIO-Delivery-ID": string;
  };
};
